import { render, staticRenderFns } from "./BuySeatForm.vue?vue&type=template&id=d71c8532&"
import script from "./BuySeatForm.vue?vue&type=script&lang=js&"
export * from "./BuySeatForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports